export const COMPOSE_MESSAGE_CONTAINER_TAG_NAME = 'compose-message-container';
